import { Component, Input, Output, EventEmitter, ElementRef, ViewChildren, QueryList, HostListener } from "@angular/core";

import { Helper } from "../../../../../4services/2helper";
import { UsersService } from '@app/services/users.service'
import { PagerService } from "@app/services/pager.service";
import { SitesService } from "@app/services/sites.service";
import { c_components } from "../../../../../3ui/2components";
import { Modal } from '@app/model/modal'
import { lastValueFrom } from 'rxjs';

@Component({
    selector: "c_dtable_app_users_list_component",
    templateUrl: "./c_dtable_app_users_list_component.html",
    styleUrls: ["../../common.scss", "./c_dtable_app_users_list_component.scss"],
    standalone: false
})
export class c_dtable_app_users_list_component {
  @ViewChildren('actionMenus', {read: ElementRef}) actionMenus: QueryList<any>
  @Input() public searchText: string;
  @Input() appUsers: any[]
  @Output() selectedUsersChange = new EventEmitter<any[]>();
  @Output() userDeleted = new EventEmitter<void>();

  dealerId = this.usersService.dealerId;
  isLoading = false;
  accesses: any[] = [];
  allSelected = false;

  pagedAppUsers: any[] = []; // site에 속해있는 app user
  selectedAppUsers: any[] = []; // 선택된 app users
  originalAppUsers: any[] = [];

  // permission
  hasReadAppUsersPermission = false
  hasDeleteAppUsersPermission = false;

  pager: any = {};
  curPage = 1;
  totalSite = 0;
  pageOffset = 10;
  pageOffsetStart = 1;
  pageOffsetEnd = 1;
  pagedItems: any[];

  curSort = {};
  sort = {
    sortColumn:'',
    sortDirection: ''
  }

  m_warning: Modal = new Modal();

  constructor(
    private usersService: UsersService,
    private pagerService: PagerService,
    private sitesService: SitesService,
    private c_components: c_components,
    private helper: Helper,
  ) {}

  // --------------------------------------------------------------------------------
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.actionMenus) {
      const actionMenus = this.actionMenus.toArray();
      actionMenus.forEach(actionMenu => {
        this.pagedItems.forEach(appUsers=> {
          if (('appUsers-'+appUsers?.user_id) === (actionMenu.nativeElement.id+'')) {
            if (!actionMenu.nativeElement.contains(event.target)) {
              appUsers['isShowMenu'] = false;
            }
          }
        })
      })
    }
  }

  async ngOnInit() {
    await this.usersService.loadMe();
    await this.load_my_permissions_only_if_not_loaded();
    this.checkPermission();
  }

  ngOnChanges(changes) {
    if (changes.searchText) {
      const prev = changes.searchText.previousValue;
      const curr = changes.searchText.currentValue;
  
      if (curr !== prev && curr != null) {
        this.searchAppUsers(curr);
      }
    }
  
    if (changes['appUsers'] && this.appUsers) {
      this.originalAppUsers = this.appUsers.map(user => ({
        ...user,
        isSelected: false
      }));
  
      this.allSelected = false;
      this.selectedAppUsers = [];
  
      if (this.searchText != null) {
        this.searchAppUsers(this.searchText);
      } else {
        this.pagedAppUsers = [...this.originalAppUsers];
        this.setPage(1);
      }
    }
  }

  checkPermission() {
    this.hasReadAppUsersPermission = this.helper.permission.has("dealer_site_member_read")
    this.hasDeleteAppUsersPermission = this.helper.permission.has("dealer_site_member_delete")
  }

  async load_my_permissions_only_if_not_loaded(){
    await this.helper.permission.load_my_permissions_only_if_not_loaded()
  }

  // img
  computedImgError(appUser){
    return appUser.provider_picture = null;
  }

  goToDetail(appUserId){
    this.helper.router.navigate_to(`/reports/app-users/${appUserId}`);
  }

  setAppUsersMorePosition(appUsers) {
    const docElem = document.documentElement
    let elem = document.getElementById('appUsers-'+appUsers?.user_id);
    let more = document.getElementById('appUsers-more-'+appUsers?.user_id);
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right + 5
    const posY = rect.top - 22;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }


  toggleMenu(appUsers){
    const targetMenu = appUsers.isShowMenu;
    appUsers.isShowMenu = !targetMenu;
  }

  openRemoveDialog() {
    this.c_components.dialog.open("app_user_remove", this.selectedAppUsers)
  }

  onSorted(sort: { sortColumn: string; sortDirection: string }) {
    const { sortColumn, sortDirection } = sort;
    if (!sortColumn || !sortDirection) return;
  
    const isAsc = sortDirection === 'asc';
    this.sort = { sortColumn, sortDirection };
  
    this.pagedAppUsers.sort((a, b) => {
      switch (sortColumn) {
        case 'nameLabel': return this.compare(a.email?.toLowerCase(), b.email?.toLowerCase(), isAsc);
        case 'sitesLabel': return this.compare(+a.site_count, +b.site_count, isAsc);
      }
    });
  
    this.setPage(1);
  }
  
  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // pagination
  setPage(page: number) {
    if (!this.pagedAppUsers || this.pagedAppUsers.length === 0) {
      this.pagedItems = [];
      this.totalSite = 0;
      this.pager = {};
      this.curPage = 1;
      this.pageOffsetStart = 0;
      this.pageOffsetEnd = 0;
      return;
    }

    const totalPages = Math.ceil(this.pagedAppUsers.length / this.pageOffset);
    page = Math.max(1, Math.min(page, totalPages));

    this.pager = this.pagerService.getPager(
      this.pagedAppUsers.length, 
      page, 
      this.pageOffset
    );

    this.pagedItems = this.pagedAppUsers.slice(
      this.pager.startIndex, 
      this.pager.endIndex + 1
    );

    this.totalSite = this.pagedAppUsers.length;
    this.curPage = this.pager.currentPage;
    this.pageOffsetStart = this.pager.startIndex + 1;
    this.pageOffsetEnd = Math.min(this.pager.endIndex + 1, this.totalSite);
  }

  areAllUsersSelected(change: any) {
    this.pagedItems.forEach(user => {
      user.isSelected = change.checked;
    });
    
    this.selectedAppUsers = this.originalAppUsers.filter(user => user.isSelected);
    this.selectedUsersChange.emit(this.selectedAppUsers);
  }

  checkIsUsersSelected(event: any) {    
    this.selectedAppUsers = this.originalAppUsers.filter(user => user.isSelected);
    this.selectedUsersChange.emit(this.selectedAppUsers);
  }

  searchAppUsers(searchValue: string) {
    const search = (searchValue || '').toLowerCase().trim();
  
    this.pagedAppUsers = this.originalAppUsers.filter(user => {
      const email = (user.email || '').toLowerCase();
      return email.includes(search);
    });
  
    this.setPage(1);
  }
  
  deleteSites(appUsers) {
    this.c_components.dialog.open("warning", {
      header: `Do you want to delete ${appUsers.email} ?`,
      contents: `
        <p>Deleted from all the sites they belong.</p>
      `,
      submit_btn: "Delete",
      submit_class: ["button-danger"],
      icon: 'warning',
      isConfirm: false,
      color: 'orange',
      submit_func: () => {
        this.deleteFromSites(appUsers)
      },
    });
  }

  async deleteFromSites(user) {
    this.isLoading = true
    const title = `Delete from Sites`
    const msg = `${title} ${user.email} - Success`
    const dealerId = this.dealerId()
    const userId = user.user_id
    const sites = user.site_ids

    const promises = sites.map(site =>
      lastValueFrom(this.sitesService.deleteSiteMember(dealerId, site, userId))
    );

    try {
      await Promise.all(promises)
      this.isLoading = false;
      this.openConfirmDialog(title, msg);
    } catch(err) {
      this.openErrorDialog(err, title);
    } finally {
      this.isLoading = false
    }
  }

  openConfirmDialog(header = "", msg = "", icon = "done", color = "green", doAction = false) {
    this.c_components.dialog.open("warning", {
      header: header,
      contents: `
        <p>${msg}</b></p>
      `,
      submit_btn: "OK",
      submit_class: ["button-primary"],
      icon: icon,
      isConfirm: true,
      color: color,
      submit_func: () => {
        this.userDeleted.emit();
      },
    });
  }

  openErrorDialog(err, title) {
    let msg = "failed.";
    if (err.error) {
      if (err.error.message) {
        msg = err.error.message;
      }
    }
    if (err._body) {
      msg = JSON.parse(err._body).message;
    }
    setTimeout(() => {
      this.openConfirmDialog(title, msg, "warning", "orange");
    }, 200);
  }
}